import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  GET_MESSAGES_BY_JOB_ID,
  getMessagesByJobId,
  postMessage,
  requestAdminMessage,
} from '../../actions';
import { createLoadingSelector } from '../../api/selectors';
import CustomSpinner from '../../commonComponents/CustomSpinner';
import history from '../../browserHistory';
import chatSendButton from '../../images/chatSendButton.png';
import '../../themes/confirm_hyg.scss';
import '../../themes/global.scss';
import ChatHeader from './ChatHeader';
import GuidelinesPortal from './GuidelinesPortal';
import {
  renderAdminMessage,
  renderOpponentMessage,
  renderSupportCard,
  renderUserMessage,
} from './RenderFunc';

export default function Chat() {
  const params = useParams();
  const messageRef = useRef(null);

  const [newMessage, setMessage] = useState('');
  const [isGuidelineOpen, setGuidelineOpen] = useState(false);

  const jobId = history.location.state ? history.location.state.jobId : params.jobId;
  const user = useSelector((state) => state.user.user);
  const { currentUserId } = user;
  const selectedJob = useSelector((state) => {
    if (state.job.job?.id === jobId) {
      return state.job.job;
    }

    return null;
  });

  const messagedPerJob = useSelector((state) => state.messages.messagedPerJob);

  const actions = [GET_MESSAGES_BY_JOB_ID];
  const loadingSelector = createLoadingSelector(actions);
  const isLoading = useSelector((state) => loadingSelector(state));
  const [prevIsLoading, setPrevIsLoading] = useState(isLoading);

  const isPostMessageEnabled = moment(selectedJob?.local_date).diff(moment(), 'days') >= 0;

  const dispatch = useDispatch();

  const scrollToBottomMessages = () =>
    messageRef.current.scrollIntoView({ behavior: 'smooth', inline: 'start' });

  const disableRequest = () =>
    !isPostMessageEnabled || messagedPerJob.some((message) => message.type === 'ADMIN-INVITE');

  useEffect(() => {
    dispatch(getMessagesByJobId({ jobId }));

    if (selectedJob?.id === jobId && messagedPerJob.length === 0) {
      setGuidelineOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isLoading && prevIsLoading && isPostMessageEnabled) {
      scrollToBottomMessages();
    }

    setPrevIsLoading(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, messagedPerJob]);

  const renderPostMessageView = () => {
    if (!isLoading && isPostMessageEnabled) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '90%',
            alignSelf: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 50,
          }}
        >
          <textarea
            className="form-colntrol textarea"
            placeholder="Enter your message"
            multiple
            value={newMessage}
            onChange={(value) => setMessage(value.target.value)}
          />

          <img
            src={chatSendButton}
            style={{
              width: 50,
              height: 50,
              marginLeft: 30,
              cursor: 'pointer',
            }}
            alt="Send"
            onClick={() => {
              setMessage('');
              dispatch(postMessage({ jobId: selectedJob.id, message: newMessage }));
            }}
          />
        </div>
      );
    }
    return <div />;
  };
  const renderMessages = () => (
    <div
      style={{
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {messagedPerJob.map((messageEl) => {
        if (messageEl.type === 'ADMIN-INVITE') {
          return renderSupportCard();
        }
        if (messageEl.type === 'WARNING') {
          return renderSupportCard(messageEl.text, messageEl.id);
        }
        if (messageEl.author?.isAdmin && messageEl.author?.id !== currentUserId) {
          return renderAdminMessage(
            messageEl.text,
            moment(messageEl.created_at).fromNow(),
            messageEl.isLast,
            messageEl.id,
          );
        }
        if (messageEl.author?.id === currentUserId && messageEl.type === 'MESSAGE') {
          return renderUserMessage(
            messageEl.text,
            moment(messageEl.created_at).fromNow(),
            messageEl.isLast,
            messageEl.id,
          );
        }

        return renderOpponentMessage(
          messageEl.text,
          moment(messageEl.created_at).fromNow(),
          messageEl.isLast,
          messageEl.id,
        );
      })}
      <div style={{ height: 20 }} ref={messageRef} />
    </div>
  );

  return (
    <div
      className="component_container"
      style={{ flexDirection: 'column', justifyContent: 'flex-start', padding: 0 }}
    >
      <ChatHeader
        isDisabledButton={disableRequest()}
        userInfo={selectedJob?.offer_final_reciever}
        jobDate={selectedJob?.local_date}
        inviteAdminPressed={() => dispatch(requestAdminMessage({ jobId }))}
        openGuidelinePressed={() => setGuidelineOpen(true)}
        isOnsiteInterview={selectedJob?.isOnsiteInterview}
      />

      <div
        className="floating_container"
        style={{
          width: '94%',
          flexDirection: 'column',
          height: '100%',
          marginTop: 0,
        }}
      >
        <div style={{ width: '100%', minHeight: 500 }} className="chat_component">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '70%' }}>
              {isLoading ? <CustomSpinner isLoading={isLoading} /> : renderMessages()}
            </div>
          </div>
        </div>
        {renderPostMessageView()}

        {isGuidelineOpen ? (
          <GuidelinesPortal gotItClicked={() => setGuidelineOpen(false)} />
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}
